// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app" + "." + "fca6d657c9d4adf45f0d" + ".css";
};